import { render, staticRenderFns } from "./ProjectTableList.vue?vue&type=template&id=c3864bd0&scoped=true"
import script from "./ProjectTableList.vue?vue&type=script&lang=js"
export * from "./ProjectTableList.vue?vue&type=script&lang=js"
import style0 from "./ProjectTableList.vue?vue&type=style&index=0&id=c3864bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3864bd0",
  null
  
)

export default component.exports